import React, { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Card.module.scss';

export interface CardTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const CardTitle = forwardRef<HTMLHeadingElement, CardTitleProps>(
  ({
    className, as: Component = 'h5', children, ...props
  }, ref) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Component className={classNames(styles.title, className)} ref={ref} {...props}>
      {children}
    </Component>
  ),
);

CardTitle.displayName = 'Card.Title';

export default CardTitle;
